import React, { Component } from 'react'
import { extendObservable } from 'mobx'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import DocumentTitle from 'react-document-title'

import Error from '@components/Error/NoContent'
import Spinner from '@components/spinner'
import ContractsTable from './ContractsTable'
import FilterGroup from '@components/FilterGroup'
import { StatusFilter } from '@components/StatusFilter'
import { Dropdown } from '@components/Autocomplete'
import Pagination from '@components/Pagination'

import ContractsStore from './contracts.store'

class ContractsTab extends Component {
  static propTypes = {
    parentAccount: PropTypes.object,
    staticData: PropTypes.object
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      contractsStore: new ContractsStore(props.staticData)
    })
    const { id } = this.props.parentAccount

    this.contractsStore.query.parentAccountId = id
    this.contractsStore.filter()
  }

  filterByStatus = statuses => {
    this.contractsStore.query.page = 1
    this.contractsStore.query.contractStatuses = statuses
    this.contractsStore.filter()
  }

  filterByContractType (type) {
    this.contractsStore.query.page = 1
    this.contractsStore.query.contractTypeId = type.id
    this.contractsStore.filter()
  }

  filterByContractCode (e) {
    if (e.keyCode === 13) {
      this.contractsStore.query.page = 1
      this.contractsStore.filter()
    }
  }

  render () {
    const {
      contractsCount,
      contractTypes,
      contracts,
      error,
      loading,
      query
    } = this.contractsStore
    if (error) {
      return <Error />
    }
    if (loading) {
      return <Spinner />
    }
    const { parentAccountName } = this.props.parentAccount
    return (
      <DocumentTitle
        title={`${parentAccountName} - contracts | Atheneum Partners`}
      >
        <div className='views-wrapper'>
          <div className='project-search-bar'>
            <FilterGroup inView label='Contract status' labelClass='code-label'>
              <StatusFilter
                type='contract'
                selectedItems={this.contractsStore.query.contractStatuses}
                onChange={this.filterByStatus}
              />
            </FilterGroup>
            <FilterGroup inView label='Select type' labelClass='code-label'>
              <Dropdown
                valueIsId
                itemToString={item => item && item.name}
                options={[{ id: 0, name: 'All' }].concat(contractTypes)}
                selectedItem={query.contractTypeId}
                onChange={type => {
                  this.filterByContractType(type)
                }}
              />
            </FilterGroup>
            <FilterGroup inView label='Contract code' labelClass='code-label'>
              <input
                onKeyDown={e => {
                  this.filterByContractCode(e)
                }}
                onChange={e =>
                  (this.contractsStore.query.searchString = e.target.value)
                }
                value={query.searchString}
                onBlur={() => this.contractsStore.filter()}
              />
            </FilterGroup>
          </div>
          {contracts && contractsCount ? (
            <ContractsTable
              contracts={contracts}
              parentAccountName={parentAccountName}
            />
          ) : (
            <Error label={'No contracts match the current search parameters'} />
          )}
          <Pagination
            total={contractsCount}
            perPage={10}
            page={query.page}
            onChange={p => this.contractsStore.changePage(p)}
          />
        </div>
      </DocumentTitle>
    )
  }
}

export default inject('staticData')(observer(ContractsTab))
